import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TitleCasePipe } from '@angular/common';
import {
  BreadcrumbItem,
  BreadcrumbService,
} from '../../services/breadcrumb.service';
import { UserRoleService } from '../../services/user-role.service';
import { UserActions } from 'src/app/shared/models/user';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { ClaimDataService } from 'src/app/shared/services/claim-data.service';
import { SearchResult } from 'src/app/shared/models/search-result';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { TranslationService } from '../../services/translation.service';
import { InpageAliasService } from '../../services/inpage-alias.service';

@Component({
    selector: 'app-claim-breadcrumb',
    template: `
    <nav
      class="tw-w-full tw-flex tw-flex-wrap container tw-items-center"
      aria-label="Breadcrumb"
      role="navigation"
      >
      @for (item of breadcrumb.items | async; track item; let last = $last) {
        @if(!item?.label?.includes('ndefined')){
          @if (last) {
            <span
              role="navigation"
              class="tw-font-bold app-color-slate"
              >
              <div>
                {{ item.label }} <span class="sr-only">{{ 'Current Page' }} </span>
              </div>
            </span>
          } @else {
            <a
              [attr.id]="item.label"
              (click)="navigate(item)"
              (keydown.Enter)="navigate(item)"
              tabindex="0"
              [attr.aria-label]="'Navigate to ' + item.label"
              >{{ item.label }}</a
              >
              <span class="delimiter">
                <mat-icon class="delimiter-icon app-color-slate"
                  >chevron_right</mat-icon
                  >
                </span>
              }
            }
          }
          <span [attr.id]="'labelledbybreadcrumb'" hidden
            >{{ 'Navigate to' }}
          </span>
          @if (helpText) {
            <app-help-button
              [message]="helpText"
              [size]="24"
              [id]="'breadCrumb'"
            ></app-help-button>
          }
        </nav>
    `,
    styles: [
        `
      .container {
        font-size: 15px;
        min-height: 56px;
        padding-left: 10px;
        flex-direction: row;
      }

      .delimiter {
        padding-left: 2px;
        padding-right: 2px;
      }

      .delimiter-icon {
        margin-top: 6px;
        height: 16px;
        width: 16px;
        font-size: 16px;
      }

      .helpIcon {
        vertical-align: top;
      }
      @media (max-width: 800px) {
        .hideIconMobile {
          display: none;
          visibility: hidden;
        }
      }

      .smallhelpicon {
        font-size: 25px !important;
        margin-left: 5px;
      }
    `,
    ],
    standalone: false,
    providers: [TitleCasePipe]
})
export class ClaimBreadcrumbComponent extends BaseComponent implements OnInit {
  @Input()
  helpText: string;

  employeeAlias: string;

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  private currentClaim: SearchResult | null = null;

  constructor(
    public breadcrumb: BreadcrumbService,
    private router: Router,
    public userRole: UserRoleService,
    private claimDataService: ClaimDataService,
    private translationService: TranslationService,
    private inpageAliasService: InpageAliasService,
    private titleCasePipe: TitleCasePipe
  ) {
    super();
  }

  async ngOnInit() {
    this.breadcrumb.build();

    this.employeeAlias = await this.inpageAliasService.get('employeeSingular');

    this.subs.sink = this.claimDataService.currentClaim$.subscribe((claim) => {
      this.currentClaim = claim;
    });

    const employeeSearchLabel = this.titleCasePipe.transform(this.employeeAlias) + ' ' + this.translationService.getTranslationForKey('Search', this.translationRequest);

    this.breadcrumb.items.forEach((item) => {
      if (
        item.length &&
        item[0].label?.includes(
          this.translationService.getTranslationForKey(
            'Search',
            this.translationRequest
          )
        )
      ) {
        if (
          item[0].label !==
          this.translationService.getTranslationForKey(
            'Employee Search',
            this.translationRequest
          )
        ) {
          if (this.userRole.auditor) {
            item[0].label = employeeSearchLabel;
          } else {
            item[0].label = this.translationService.getTranslationForKey(
              'Claim search',
              this.translationRequest
            );
          }
        }
        else{
          item[0].label = employeeSearchLabel;
        }
      }
    });
  }

  navigate(item: BreadcrumbItem) {
    const sanitizedLabel = item.label?.replace(/\*/g, 'X') || 'Breadcrumb';

    if (this.currentClaim) {
      this.FeatureLoggingWithClaim(
        'BreadcrumbNavigation',
        sanitizedLabel,
        'Breadcrumb',
        this.currentClaim
      );
    } else {
      this.FeatureLogging('BreadcrumbNavigation', sanitizedLabel, 'Breadcrumb');
    }

    if (this.userRole.manager && item.path == '/dashboard') {
      sessionStorage.setItem('mgrAction', JSON.stringify(UserActions[0]));
    }
    this.router.navigate([item.path], {
      queryParams: item.queryParams,
    });
  }
}
